// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1X5yE","label":"Completed_label__1AfT5"};